import { useCssVars as _useCssVars, unref as _unref, defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

import {ref,computed,watch, onMounted, onUnmounted, nextTick} from 'vue';
import ChevronDown from './svg/ChevronDown.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ExpandableText',
  props: {
    modelValue: { type: Boolean, default: undefined },
    maxLines: { default: 1 }
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {

_useCssVars(_ctx => ({
  "736f69a0": (_ctx.maxLines)
}))

const props = __props;
const emits = __emit;
const _expand = ref(props.modelValue);
const expand = computed({
    get() {
        return props.modelValue ?? _expand.value;
    },
    set(val) {
        emits('update:modelValue', val);
        _expand.value = val;
    }
});
const overflow = ref(false);
const content = ref<HTMLElement>();
const ro = new ResizeObserver(checkOverflow);
function checkOverflow() {
    setTimeout(()=>{
        if (content.value && !expand.value)
            {overflow.value = content.value.scrollWidth > content.value.clientWidth || content.value.scrollHeight > content.value.clientHeight;}
        },0);
}
function onExpandClicked(e: MouseEvent) {
    expand.value=!expand.value;
    e.stopPropagation();
}
watch(()=>props.modelValue, (val)=>{
    _expand.value=val
});
onMounted(()=>{
    checkOverflow();
    if (content.value) {
        ro.observe(content.value);
    } else {
        console.error('ExpandableText failed to assign content ref');
    }
});
onUnmounted(()=>{
    ro.disconnect();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(['expandable', { expand: expand.value }])
  }, [
    _createElementVNode("div", {
      ref_key: "content",
      ref: content,
      class: "collapsible"
    }, [
      _renderSlot(_ctx.$slots, "default")
    ], 512),
    (overflow.value)
      ? (_openBlock(), _createBlock(ChevronDown, {
          key: 0,
          class: "chevron",
          onClick: onExpandClicked
        }))
      : _createCommentVNode("", true)
  ], 2))
}
}

})